import React from 'react';
import ModalPage from '../ModalPage';
import AuthenticatorAuth from './AuthenticatorAuth';
import SMSAuth from './SMSAuth';

export default function TwoFactorAuth ({ type, onCancel, last4, ...rest }) {
    return (
        <ModalPage title="2-Factor Authentication" style={{ backgroundColor: '#485CC7' }}>
            <div>
                <img
                    style={{ width: 70, height: 70, marginTop: 5, marginBottom: 20, marginLeft: 'auto', marginRight: 'auto', display: 'block' }}
                    src={require('../../images/lock.png')}
                    alt="Lock icon"
                />
                <div style={{ fontSize: 16, fontWeight: 'normal', lineHeight: 1.4, textAlign: 'center', marginBottom: 10 }}>
                    This account has been secured with 2-Factor authentication.<br/>Follow the instructions below to log in.
                </div>
                {type === 'AUTHENTICATOR' ? <AuthenticatorAuth {...rest} /> : null}
                {type === 'SMS' ? <SMSAuth {...rest} last4={last4} /> : null}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" to="/login" onClick={(e)=>{
                    e.preventDefault();
                    onCancel()
                }} style={{fontSize: 14, textDecoration: 'none'}}>Go back to login</a>
            </div>
        </ModalPage>
    );
};